import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
const SharedMedianCalculator = () => {
    const [data, setData] = useState('');
    const [median, setMedian] = useState('');
    const [explanation, setExplanation] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!data) {
            setError('يرجى إدخال البيانات');
            setMedian('');
            setExplanation('');
            return;
        }
        const values = data.split(',').map((value) => parseFloat(value));
        if (values.some(isNaN)) {
            setError('الرجاء إدخال قيم رقمية صحيحة مفصولة بفاصلة واحدة بينها');
            setMedian('');
            setExplanation('');
            return;
        }
        values.sort((a, b) => a - b);
        const n = values.length;
        if (n % 2 === 1) {
            const middleIndex = Math.floor(n / 2);
            const medianValue = values[middleIndex];
            setMedian(medianValue.toFixed(2));
            setExplanation(
                `الوسيط: ${medianValue}\n\n` +
                `البيانات مرتبة بشكل تصاعدي. الوسيط هو القيمة الوسطية في القائمة التي تأتي في الموقع رقم ${middleIndex + 1} بعد الترتيب.`
            );
        } else {
            const middleIndex1 = n / 2 - 1;
            const middleIndex2 = n / 2;
            const medianValue1 = values[middleIndex1];
            const medianValue2 = values[middleIndex2];
            const medianValue = (medianValue1 + medianValue2) / 2;
            setMedian(medianValue.toFixed(2));
            setExplanation(
                `الوسيط: (${medianValue1} + ${medianValue2}) / 2 = ${medianValue.toFixed(2)}\n\n` +
                `البيانات مرتبة بشكل تصاعدي. الوسيط هو المتوسط الحسابي بين القيمتين في المواقع ${middleIndex1 + 1} و ${middleIndex2 + 1} بعد الترتيب.`
            );
        }
        setError('');
    };
    return (
        <div dir="rtl">
            <div>
                <div className="form-group d-flex ">
                    <input
                        type="text"
                        placeholder="البيانات (مفصولة بفاصلة)"
                        value={data}
                        onChange={(e) => setData(e.target.value)}
                        className="form-control"
                        style={{ width: '300px' }}
                    />
                    <div style={{ width: '75px', marginLeft: '4px' }}>
                        <Tooltip title="مثال : 1,2,23,7,1,8">
                            <button
                                style={{
                                    background: "none",
                                    border: "none",
                                    padding: "8px",
                                    cursor: "pointer",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    fill="currentColor"
                                >
                                    <path d="M11 9h2V7h-2v2zm1-7C6.48 2 2 6.48 2 12s4.48 10 10 10 
             10-4.48 10-10S17.52 2 12 2zm0 18
             c-4.41 0-8-3.59-8-8s3.59-8 
             8-8 8 3.59 8 8-3.59 8-8 8zm-1-5h2v-6h-2v6z"/>
                                </svg>
                            </button>
                        </Tooltip>
                    </div>
                </div>
                <br />
                <button
                    className="btn btn-success"
                    style={{ fontSize: '20px' }}
                    onClick={handleCalculate}
                >
                    احسب الوسيط
                </button>
            </div>
            <br />
            <div>
                {error !== '' ? (
                    <p className='p-3 mb-2 bg-warning text-white'>خطأ: {error}</p>
                ) : (
                    <>
                        {median !== '' && (
                            <>
                                <p className='p-3 mb-2 bg-success text-white'>
                                    الوسيط: {median}
                                </p>
                                {explanation !== '' && (
                                    <p className='p-3 mb-2 bg-info text-black'>
                                        خطوات الحل: <br />{explanation}
                                    </p>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
export default SharedMedianCalculator;
